

















import Component from 'vue-class-component'
import Vue from 'vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import { Prop } from 'vue-property-decorator'

@Component({
  name: 'respondeco-default-modal-footer',
  components: { UnifyButton },
})
export default class RespondecoDefaultModalFooter extends Vue {
  @Prop({
    default: 'common.cancel',
    type: String,
  })
  public readonly cancel!: string

  @Prop({
    type: Boolean,
  })
  public readonly disabled!: boolean

  @Prop({
    type: Boolean,
  })
  public readonly loading!: boolean

  @Prop({
    default: 'common.ok',
    type: String,
  })
  public readonly ok!: string
}
